<template>
   <div class="hours">
        <select v-if="timeToDisplay.length > 0" class="form-control" v-model="selectedTime" v-on:change="updateValue()">
            <!-- <option value="">Time</option> -->
            <option
                v-for="(time,i) in timeToDisplay"
                :key="i"
                v-bind:value="time"
            >{{time.displayFormat}}</option>
        </select>
        <span v-if="timeToDisplay.length == 0" class="text-danger">Time expired</span>
    </div>     
</template>
<script>
export default {
  name: "validtime",
  props: ['defaultTime'],
watch: {
    $props: {
      handler: function() {
        this.defaultValidTime = this.defaultTime;
        let hour = this.defaultTime.split(":")[0];
        let minute = this.defaultTime.split(":")[1];
        if(hour || minute) this.setDefaultTime(hour,minute);
        
      },
      deep: true
    }
  },
  data() {
    return {
        dayTime : [9,10,11,12,13,14,15,16],
        minutesInQuater : [0,15,30,45],
        timeToDisplay : [],
        selectedTime : null,
        defaultValidTime : ""
    };
  },
  methods: {
    updateValue: function () {
      var dt = new Date();
      dt.setHours(this.selectedTime.hour); 
      dt.setMinutes(this.selectedTime.minute);
      //this.moment(dt).utc().format("YYYY-MM-DD HH:mm:ss");
      //console.log(this.selectedTime.hour ,this.selectedTime.minute ) 
      this.$emit('input', this.moment(dt).utc().format("YYYY-MM-DD HH:mm"));
    },
    getTimeList(){
        var minutesToAdd=15;
        var currentDate = new Date();
        var futureDate = new Date(currentDate.getTime() + minutesToAdd*60000);
        let hour = futureDate.getHours();
        this.timeToDisplay = [];
    
        this.dayTime.forEach((element) => {
            if(element >= hour){
                this.minutesInQuater.forEach(min => {
                    if(element == new Date().getHours()){
                        if(min > new Date().getMinutes()){
                            let converTime  = element < 12 ? 'AM' : 'PM';
                            let convertMinutes = min == 0 ? "00" : min;
                            let convertHour = element % 12  == 0 ? 12 : element % 12;
                            this.timeToDisplay.push({"hour": element , "minute" :convertMinutes ,"displayFormat": convertHour +":"+ convertMinutes +" "+ converTime })
                        }   
                        }else{
                            let converTime  = element < 12 ? 'AM' : 'PM';
                            let convertMinutes = min == 0 ? "00" : min;
                            let convertHour = element % 12  == 0 ? 12 : element % 12;
                            this.timeToDisplay.push({"hour": element , "minute" :convertMinutes,"displayFormat": convertHour +":"+ convertMinutes +" "+ converTime  })
                        }
                })
            }
        });
    },
    setDefaultTime(hour,minute){
        this.timeToDisplay.forEach(ele => {
            //console.log(ele.hour)
            let hourIn12format = ele.hour % 12  == 0 ? 12 : ele.hour % 12;
            if(hourIn12format == hour && ele.minute == minute){
                this.selectedTime = ele;
                this.updateValue();
            }
        })
    }
  },
  mounted() {
    this.getTimeList();
  }
};
</script>
<style scoped>
.hours{
    display: flex;
}
</style>